<div class="search-input-bar">
  <input #searchInput
         class="search-input search-background-neutral"
         [style]="inputStyle"
         type="text"
         [(ngModel)]="searchText"
         placeholder="{{placeholder}}"
         (keydown.enter)="search.emit(searchText)"/>
  <i class="search-left {{iconClass}}"></i>
  <!--   <div style="z-index: unset" class="search-counters">{{resultCount}}/{{totalCount}}</div> -->
  <i class="search-reset fas fa-times"
     style="padding-right: 0.5rem;"
     tabindex="-1"
     *ngIf="searchText && searchText != ''"
     (click)="resetSearch()">
  </i>
</div>
